export default "__VITE_ASSET__CDFjDnlw__"